import { withTheme } from '@rneui/themed';
import React from 'react';
const UnthemedRenderHtml = (props) => (React.createElement("div", { style: props?.baseStyle || {}, dangerouslySetInnerHTML: { __html: props.html } }));
export const RenderHtml = withTheme(UnthemedRenderHtml, 'RenderHtml');
export default RenderHtml;
//# sourceMappingURL=RenderHtml.web.js.map